// extracted by mini-css-extract-plugin
export default {"root":"styles_root__hM7Ox","title":"styles_title__tlp0g"};